<template>
    <h1 class="page-title">
        {{ $t('404.pageTitle') }}
    </h1>
    <p>{{ $t('404.pageDescription') }}</p>
    <router-link
        v-slot="{ navigate }"
        to="/"
        custom
    >
        <button
            class="button--accent"
            role="link"
            @click="navigate"
            @keypress.enter="navigate"
        >
            {{ $t('404.homeButton') }}
        </button>
    </router-link>
</template>

<script>
export default {
    name: 'PageNotFound',
};
</script>